/**
 * Active Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.activeFormatter = function(value, row) {
    if (value === 1) {
        return '<span class="badge bg-success">'+__('Active')+'</span>';
    } else {
        return '<span class="badge bg-danger">'+__('Inactive')+'</span>';
    }
};
